<template>
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card  border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <router-link to="/">
                      <img class="img-responsive" id="logo" src="../../public/images/Shift2DC_logo.png">
                    </router-link>
                    <h1 class="h5 text-gray-900 mb-4">{{ $t('Reset_password') }}</h1>
                    <div v-if="error.message" class="alert alert-danger" role="alert">
                      {{ error.message }}
                    </div>
                    <div v-if="success" class="alert alert-success" role="alert">
                      {{ $t('Email_sent_recover_password') }}
                    </div>
                  </div>
                  <form class="user" v-on:submit="send">
                    <div class="form-group">
                      <input type="text" v-model="email" class="form-control form-control-user" aria-describedby="emailHelp" :placeholder="$t('Email_address')">
                    </div>
                    <input type="submit" :value="$t('Send')" class="btn btn-primary btn-user btn-block">
                  </form>
                  <hr>
                  <div class="text-center mt-2">
                    <SelectLanguage></SelectLanguage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectLanguage from './SelectLanguage.vue'

export default  {
  name: 'forgot-password',
  props: [],
  components: {
    SelectLanguage,
  },
  data() {
    return {
      email: "",
      error: {
        code: null,
        message: null
      },
      success: null
    }
  },
  methods: {
    send: function(e){
      e.preventDefault()
      if (this.email == "") return
      this.$store.dispatch('forgotPassword', this.email).then(() => {
        this.email = ""
        this.success = true
      }).catch(e => {
        this.error.code = e.response.data.error
        this.error.message = this.$i18n.t(e.response.data.error)
      })
    }
  },
  computed: {
    current_lang: function(){
      return this.$i18n.locale
    }
  },
  watch: {
    current_lang: function(){
      if (this.error.code) this.error.message = this.$i18n.t(this.error.code)
    }
  }
}
</script>

<style scoped>
.bg-login-image {
  background: url("../../public/images/forgot_password.png");
  background-position: center;
  background-size: cover;
}

#logo{
  max-height: 130px;
}
</style>
